export default {
  banner: {
    title: 'Sind Sie ein Lehrbetrieb?',
    text: 'Nutzen Sie den Service der Wirtschaftskammer Österreich und verschaffen Sie Ihren Ausbilder:innen und Lehrlingen kostenlos Zugang zur größten digitalen Aus- und Weiterbildungsplattform Österreichs!',
    action: 'Jetzt anfragen',
  },
  upgrade_modal: {
    title:
      'Geben Sie Ihre WKO Mitgliedsnummer ein, um mit dem Upgrade fortzufahren',
    text: 'Mit dem Klick auf "Bestätigen" aktualisieren Sie Ihr Profil',
    request_sent: {
      title: 'Anfrage versendet!',
      text: 'Sie werden per E-Mail informiert, sobald wir Ihre Anfrage geprüft haben.',
    },
  },
}
